import React from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

function VideoModal({ isModalOpen, setIsModalOpen, activeVideo }) {
  return (
    <Modal closeIcon open={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <Modal.Content>
        <VideoPlayerBlock>
          <ReactPlayer
            controls
            url={activeVideo} 
            width="100%"
            height="100%"
          />
        </VideoPlayerBlock>
      </Modal.Content>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  const { activeVideo } = state.newYouslim;

  return {
    activeVideo,
  };
};

export default connect(mapStateToProps)(VideoModal);

const VideoPlayerBlock = styled.div`
  height: 500px;
`;



// WEBPACK FOOTER //
// ./src/Components/Videos/VideoModal/index.jsx